import React from "react";
import "./userReview.css";

const UserReview = ({ review }) => {
  const { name, img, ratings, comment } = review;
  return (
    <div className="user-review-container">
      <div className="">
        <div className="user-img">
          <img src={img} alt="" />
        </div>
        <div className="user-info">
          <h1>{name}</h1>
          <p>Comment: {comment}</p>
          <p>
            <small>Ratings:{ratings}⭐⭐⭐⭐⭐</small>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserReview;
